import request from '../../request';

function getQueryByField(field) {
  return `
    query getNewsArticles(
      $keywords: [String],
      $limit: Int,
      $offset: Int,
      $featured: Boolean,
      $notInIds: [Int]
      $sort: NewsArticleSorting
      $inDays: Int
      $inIds: [Int]
      $categoryIds: [Int]
      $inCreatedByIds: [Int]
    ) {
      ${field}(
        keywords: $keywords,
        limit: $limit,
        offset: $offset,
        featured: $featured,
        notInIds: $notInIds
        sort: $sort
        inDays: $inDays
        inIds: $inIds
        categoryIds: $categoryIds
        inCreatedByIds: $inCreatedByIds
      ) {
        id
        title
        url
        imageUrl
        description
      }
    }
  `;
}

export default async function getNewsArticles(variables = {}, field) {
  const result = await request(getQueryByField(field), variables);

  return result[field];
}
